<nz-form-item class="input-field">
    <nz-form-control [formGroup]="this.form">
        <label class="input-field-label">
            <div class="mb-3px color-grey">{{this.label}}</div>
            <nz-input-group [nzSuffix]="nzSuffix" [nzSize]="size" [class]="inputGroupClass">
                <textarea nz-input [placeholder]="this.placeholder" [nzSize]="size" class="color-grey"
                    (ngModelChange)="handleOnChange($event)" formControlName="{{this.formName}}"
                    [nzAutosize]="fieldSize"></textarea>
            </nz-input-group>
        </label>
        <app-validation-errors
            *ngIf="showValidationError && (this.form?.controls[this.formName].touched || this.form?.controls[this.formName].dirty)"
            [errors]="this.form?.get(this.formName).errors" label="{{this.formName}}">
        </app-validation-errors>
    </nz-form-control>
</nz-form-item>
